<template>
  <div class="intro-wrapper">
    <div class="hero">

      <div class="container heading">
        <div>
          <h1>Zawał może być tylko początkiem problemów</h1>
          <h3 class="subtitle">
            Rozdzierający ból zlokalizowany za mostkiem, wyraz cierpienia na twarzy i omdlenie postawnego mężczyzny –
            tak
            najczęściej wyobrażamy sobie zawał serca. Tymczasem choroba ta może mieć zupełnie inną twarz i pojawić się
            także u kobiet, w dodatku bez ostrzeżenia i w wieku gdy nikt nie spodziewa się zawału serca.
          </h3>
        </div>
      </div>

      <div class="animation-wrapper" id="slideleft-animation-effect">
        <div class="underlay">
          <div class="document">
            <h4 class="document-title">
              Rozpoznanie:
              <span class="strikethrough-animation-wrapper">
                <span class="wrong">
                  zawał
                  <span class="strikethrough" id="strikethrough-animation-effect"></span>
                </span>
                <span class="correct" id="slideup-animation-effect">
                  SCAD
                </span>
              </span>
            </h4>
            <div class="heartbeat-wrapper">
              <Heartbeat />
            </div>
            <svg class="text-placeholders" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">
              <g>
                <rect height="1em" width="100%" x="0" v-for="(k, i) of Array(10)" :y="`${(i+1)*2}em`" :key="i" />
              </g>
            </svg>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
  import Heartbeat from '../Heartbeat.vue'
  import {
    TimelineMax,
    TweenMax
  } from 'gsap'

  export default {
    components: {
      Heartbeat
    },
    mounted() {
      if (window.innerWidth <= 1400)
        return

      const timeline = new TimelineMax()
      // triggerHook - {0,0.5,1} - animations starts from {top,center,end} of window

      timeline.add(TweenMax.to('#strikethrough-animation-effect', 2, {
        width: '100%',
        visibility: 'visible'
      }))

      timeline.add(TweenMax.to('#slideup-animation-effect', 2, {
        bottom: 0,
        opacity: 1,
        visibility: 'visible'
      }))

      const toggleTitleScene = this.$scrollmagic.scene({
        triggerElement: '#about-scad',
        triggerHook: 1,
        duration: 500
      }).setTween(timeline)

      const hideAnimationWrapperScene = this.$scrollmagic.scene({
        triggerElement: '#about-scad',
        triggerHook: 0.2,
        duration: 1000
      }).setTween(TweenMax.to('#slideleft-animation-effect', 10, {
        right: '-100%',
        opacity: 0,
      }))

      this.$scrollmagic.addScene([
        toggleTitleScene,
        hideAnimationWrapperScene
      ])
    }
  }
</script>

<style lang="scss" scoped>
@import '../../vars.scss';
  .hero {
    width: 100%;
    min-height: 100vh;
    display: flex;
    align-items: center;

    .subtitle {
      width: 50%;
      color: rgba(0, 0, 0, 0.4);
      font-size: 1.4em;

      @media(max-width: 1400px) {
        width: 100%;
      }
    }

    .heading {
      div{
        @media(max-width: 580px){
           background:rgba(255,255,255, 0.9);
            z-index:11;
            position: relative;
            padding:5px;
            border-radius:5px;
        }
      }
      @media(max-width: 1400px) {
        padding-top: 70vh;
      }

      @media(max-width: 580px) {
        padding-top: 50vh;
        // width:calc(100% - 2em);
      }

    }

    @media(max-width: 1400px) {
      display: block;
    }
  }

  .animation-wrapper {
    position: fixed;
    right: 10vw;
    top: 50vh;
    transform: translate(0, -50%);
    z-index: 10;

    @media(max-width: 1400px) {
      position: absolute;
      right: 50vw;
      top: 20vh;
      transform: translate(50%, 0);
    }
  }

  .underlay {
    position: relative;
    top: 0;
    left: 0;
    width: 50vh;
    height: 50vh;
    border-radius: 20px;
    transform: rotate(10deg);
    // background:#f4af9f;
    background: $primary;
    z-index: -1;
    box-shadow: 10px 10px 40px -12px rgba(0, 0, 0, 0.4);
    animation: scale-up-underlay-animation 1s forwards;

    @media(max-width: 1400px) {
      heigth: 10vh;
    }
  }

  .document {
    position: absolute;
    top: -5%;
    left: 50%;
    width: calc(100% - 4em);
    height: 50vh;
    transform: scale(0) rotate(-10deg) translate(-50%, -0);
    border-radius: 20px;
    background: white;
    box-shadow: 0px 0px 40px -10px rgba(0, 0, 0, 0.75);
    overflow: hidden;
    animation: scale-up-document-animation 1s .5s forwards;

    @media(max-width: 1500px) {
      transform: scale(0.8) rotate(-10deg) translate(-50%, -0);
    }
  }

  .document-title {
    padding: 1em;
    font-size: 1.5em;
    margin: 0;
    animation: fade-animation 0.5s 1.5s forwards;
    opacity: 0;
    visibility: hidden;
  }

  .wrong {
    position: relative;
  }

  .strikethrough {
    top: 50%;
    left: 0;
    width: 0;
    visibility: hidden;
    height: 4px;
    border-radius: 1px;
    display: block;
    position: absolute;
    background: $primary;
    transform: translate(0, -50%);
    z-index: 1;

  }

  .correct {
    position: relative;
    opacity: 0;
    visibility: hidden;
    bottom: -.5em;
  }

  .text-placeholders {
    padding: 1em;
    box-sizing: border-box;
    overflow: hidden;
    width: 0;
    animation: expand-text-placeholders-animation .8s 1.5s ease-in-out forwards;

    rect {
      fill: rgba(0, 0, 0, 0.15);
    }
  }

  .heartbeat-wrapper {
    width: 100%;
    display: flex;
    justify-content: center;
    animation: fade-animation 0.5s 1.5s forwards;
    visibility: hidden;
    opacity: 0;
  }

  @keyframes scale-up-underlay-animation {
    0% {
      transform: scale(0) rotate(10deg);
    }

    75% {
      transform: scale(1.1) rotate(10deg);
    }

    100% {
      transform: scale(1) rotate(10deg);
    }
  }

  @keyframes scale-up-document-animation {
    0% {
      transform: scale(0) rotate(-10deg) translate(-50%, -0);
      transform-origin: left;
    }

    75% {
      transform: scale(1.1) rotate(-10deg) translate(-50%, -0);
    }

    100% {
      transform: scale(1) rotate(-10deg) translate(-50%, -0);
    }
  }

  @keyframes expand-text-placeholders-animation {
    from {
      width: 0;
    }

    to {
      width: 100%;
    }
  }

  @keyframes fade-animation {
    from {
      opacity: 0;
      visibility: hidden;
    }

    to {
      opacity: 1;
      visibility: visible;
    }
  }
</style>